import * as React from 'react';
import {Form} from '../reusableComponents/FormComponents/Form';
import {FormFooter} from '../reusableComponents/FormComponents/FormFooter';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {ImageUpload} from '../reusableComponents/ImageUpload';
import {OrgModel} from '../../model/OrgModel';

import {saveModules} from '../../services/moduleService';
import {getCategoryDetails} from '../../services/moduleService';
import { IMAGEALLOWEDEXE } from 'src/constants/generals';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import {Async} from '../reusableComponents/Async';
import { dispatch } from 'src/utils/generalUtils';
import { actions } from 'react-redux-form';

export interface IOrgFormProps {
    model: string;
    id: string;
    orgImage?: string;
    instance?: OrgModel;
    loadDefaultValues?: Function;
    Category?: [];
    SubCategory?: [];
    onSubmit: (values) => void;
}

export interface IUserFormState {
    isL2User: boolean;
    selectedLevel: string[];
    categoryList: [];
    subCategoryList: string[];
    subCategoryOpt : string[];
    selectedCategory: string[];
    selectedSubCategory: string[];
    selectedSubLevel : string[];
    SelSubCategory : string[];
}

export class OrgForm extends React.PureComponent<IOrgFormProps, IUserFormState> {
    dropDownListObject: any;
    constructor(props: IOrgFormProps) {
        super(props);
        this.state = {isL2User: false, selectedLevel: [], categoryList: [], subCategoryList: [], subCategoryOpt: [], selectedCategory: [], selectedSubCategory: [], selectedSubLevel: [], SelSubCategory: []};
    }

    public promise = async () => {
        const CategoryArr = await getCategoryDetails();
        this.setState({categoryList: CategoryArr[0]});
        await this.setState({subCategoryList: CategoryArr[1]});
        if ( this.props.instance !== undefined ) {
            this.setState({SelSubCategory: this.props.instance.props.SubCategory});
            this.subcategoryOptions(this.props.instance.props.Category);
        }
    }

    public categoryOptions = (Opt) => {
        let categoryOptions = [];
        let idStr ='';
        if (Opt === 'select'){
            for ( let i = 0; i < this.state.categoryList.length; i++ ) {
                let arr = this.state.categoryList[i];
                idStr = arr[0];
                idStr = idStr.toString();    
                categoryOptions.push({label: arr[1], value: idStr});
            }
            if (this.state.selectedCategory.length < 0){
                this.categorySetState(categoryOptions);
            }
        }
        return categoryOptions;
    }

    public categorySetState = (categoryOptions) => {
        this.setState({
            selectedCategory: categoryOptions,
        });
    }

    public subcategoryOptions = (flag) => { 
    let subcategoryOptions = [];
    let subCategoryOptList = this.state.subCategoryList || [];
    
    let usedID = (flag && Array.isArray(flag)) ? flag : [];
    
    this.setState({ subCategoryOpt: [] });
    
    let idStr = '';
    for (let i = 0; i < usedID.length; i++) {
        let CategoryID = usedID[i];
        for (let j = 0; j < subCategoryOptList.length; j++) {
            let arr = subCategoryOptList[j];
            if (arr && arr[CategoryID]) {
                let newarr = arr[CategoryID];
                if (newarr && Array.isArray(newarr)) {
                    for (let k = 0; k < newarr.length; k++) {
                        let subCatOpt = newarr[k];
                        if (subCatOpt) {
                            idStr = subCatOpt[0];
                            idStr = idStr.toString();
                            subcategoryOptions.push({
                                label: subCatOpt[1],
                                value: idStr
                            });
                        }
                    }
                }
            }
        }
    }
    this.setState({ subCategoryOpt: subcategoryOptions });
    return subcategoryOptions;  
}

    public onCategoryChange = async (value) => {
        // const labels = this.state.selectedLevel.length > 0 ? this.state.selectedLevel : [];
        if ( value.value === undefined){
            await this.setState({
                    selectedLevel: [],
                    selectedCategory: []
                });
            if (this.props.instance) {
    this.props.instance.props.SubCategory = [];
}

            let newarr = this.subcategoryOptions([]);
            dispatch(actions.push('forms.updateOrgForm.SubCategory', []));    
            return;
        }
        // for ( let i = 0; i < labels.length; i++ ) {
        //     if ( labels[i] == value.value ) {
        //         return ;
        //     }
        // }
        //     labels.push(value.value);
            if (value.value) {
                await this.setState({
                    selectedLevel: value.value
                });
                const category = this.state.selectedLevel;
                let subnew = this.unSelectSubCategory(value.value);
                let newarr = this.subcategoryOptions(value.value);

            }
            // dispatch(actions.push('forms.updateOrgForm.SubCategory', value));
    }

    public unSelectSubCategory = async (flag) => {
    let subCategoryOptList = this.state.subCategoryList || [];
    let SelSubCategory = [];
    
    let usedID = (flag && Array.isArray(flag)) ? flag : [];
    
    let idStr = '';
    let key = Number[0];
    dispatch(actions.change('forms.updateOrgForm.SubCategory', []));    

    for ( let i = 0; i < usedID.length; i++ ) {
        let CategoryID = usedID[i];
        for ( let j = 0; j < subCategoryOptList.length; j++ ) {
            let arr = subCategoryOptList[j];
            if (arr) {
                let ObjKeys = Object.keys(arr);
                if (ObjKeys == CategoryID) {
                    key = CategoryID;
                    let newArr = arr[key];
                    if (newArr && Array.isArray(newArr)) {
                        for ( let k = 0; k < newArr.length; k++ ) {
                            let subCatOpt = newArr[k];
                            if (subCatOpt) {
                                idStr = subCatOpt[0];
                                let def = this.state.SelSubCategory || [];
                                idStr = idStr.toString();   
                                if (def.indexOf(idStr) > -1) {
                                    SelSubCategory.push(idStr);
                                    dispatch(actions.push('forms.updateOrgForm.SubCategory', idStr));    
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    await this.setState({ SelSubCategory: SelSubCategory });
}

    public getDefaultCategory = (SelectedArr) => {
        let idStr = '';
        let categoryOptions = [];
        if (SelectedArr) {
            for ( let i = 0; i <SelectedArr.length; i++ ) {
                for ( let j = 0; j < this.state.categoryList.length; j++ ) {
                    let arr = this.state.categoryList[j];
                    if(SelectedArr[i] == arr[0]){
                        idStr = arr[0];
                        idStr = idStr.toString(); 
                        categoryOptions.push({label: arr[1], value: idStr});
                    }
                }
            }
        
            this.setState({
                selectedLevel: SelectedArr
            });
        }
        return categoryOptions;
   
    }

    public getDefaultSubCategory = (SelectedArr) => {
    let subcategoryOptions = [];
    let subCategoryOptList = this.state.subCategoryList || [];
    let idStr = '';
    
    if (SelectedArr && Array.isArray(SelectedArr) && SelectedArr.length > 0) {
        for (let i = 0; i < SelectedArr.length; i++) {
            let SubCategoryID = SelectedArr[i];
            for (let j = 0; j < subCategoryOptList.length; j++) {
                let arr = subCategoryOptList[j];
                if (arr) {
                    let categoryKeys = Object.keys(arr);
                    for (let key of categoryKeys) {
                        let newarr = arr[key];
                        if (newarr && Array.isArray(newarr)) {
                            for (let k = 0; k < newarr.length; k++) {
                                let subCatOpt = newarr[k];
                                if (subCatOpt && SubCategoryID == subCatOpt[0]) {
                                    idStr = subCatOpt[0];
                                    idStr = idStr.toString();
                                    subcategoryOptions.push({
                                        label: subCatOpt[1],
                                        value: idStr
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return subcategoryOptions;
}

    get orgPic() {
        return this.refs.orgPic ? this.refs.orgPic.images : '';
    }

    public refs: {
        orgPic: ImageUpload;
    };

    onSubmit = (values) => {
        this.props.onSubmit(values);
    }

    public renderContent = () => {
        const {instance} = this.props;
        return <Form
                loadDefaultValues={this.props.loadDefaultValues}
                model={this.props.model}
                onSubmit={this.onSubmit}
                className="user-form org-form"
                 >
                <InputField
                    id="orgName"
                    hintText=""
                    label="Name:"
                    type="text"
                    required
                    defaultValue={instance && instance.props.OrganizationName}
                    model=".OrganizationName"
                />

                <div key="1" className="text-input">
                    <div className="input-label" style={{width: '40%'}}>
                        <label>Logo Picture:</label>
                    </div>
                    <div className="input-field">
                        <ImageUpload
                            base64Image={this.props.orgImage}
                            instance={this.props.instance}
                            Extensions={IMAGEALLOWEDEXE}
                            ref="orgPic"
                        />
                    </div>
                </div>
                <InputField
                    id="Category"
                    hintText=""
                    color={'white'}
                    label="Category:"
                    required
                    type="selectById"
                    model=".Category"
                    noChips={true}
                    multi
                    menuItems={this.categoryOptions('select')}
                    // menuItems={this.state.selectedCategory.length > 0 ? this.state.selectedCategory : this.categoryOptions('select')}
                    defaultValue={instance && this.getDefaultCategory(instance.props.Category)}
                    onChange={this.onCategoryChange}
                />
                <InputField
                    id="SubCategory"
                    hintText=""
                    color={'white'}
                    label="Sub Category:"
                    required
                    type="selectById"
                    model=".SubCategory"
                    noChips={true}
                    multi
                    menuItems={this.state.subCategoryOpt ? this.state.subCategoryOpt : this.subcategoryOptions([])}
                    defaultValue={instance && this.getDefaultSubCategory(this.state.SelSubCategory)}
                />
                <FormFooter submitLabel={instance ? 'Update' : 'Create'}/>
            </Form>;
        }
    public render() {
           return  <Async
            identifier="ModuleUpdateForm"
            promise={this.promise}
            content={this.renderContent()}
            loader={<Loader type="async"/>}
            error={<ErrorPage/>}
        />;
    }
}
// Org Form 01/19/2023  06:19PM




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/OrgForm.tsx